import { render, staticRenderFns } from "./NoRecordsFound.vue?vue&type=template&id=0a65de0a&scoped=true&"
import script from "./NoRecordsFound.vue?vue&type=script&lang=js&"
export * from "./NoRecordsFound.vue?vue&type=script&lang=js&"
import style0 from "./NoRecordsFound.vue?vue&type=style&index=0&id=0a65de0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a65de0a",
  null
  
)

export default component.exports